import { LARISSA_DAO_ABI } from '@/abis/larissa-dao';

export const LARISSA_DAO_CONTRACT_CONFIG = {
	address: (import.meta.env.VITE_LARISSA_DAO_CONTRACT_ADDRESS || '') as `0x${string}`,
	abi: LARISSA_DAO_ABI,
} as const;
